import { isValid, parse } from 'date-fns';

export const parseDatePickerInputValue = (value: string, dateFormat: string): Date | null => {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = parse(trimmed, dateFormat, new Date());
  return isValid(parsed) ? parsed : null;
};
